import { isAcademySubdomainHost } from './academyHost';

const ACADEMY_PATH_PUBLIC =
  /^\/academy\/[^/]+(\/(lessons(\/camps\/[^/]+)?|book\/[^/]+|book-private|login|register|forgot-password|reset-password|location\/[^/]+))?$/;

const CLUB_PATH_PUBLIC =
  /^\/club\/[^/]+(\/(court-hire|join|membership|login|register|forgot-password|reset-password))?$/;

const ORG_PATH_PUBLIC =
  /^\/club-academy\/[^/]+(\/(lessons(\/camps\/[^/]+)?|book\/[^/]+|book-private|court-hire|join|membership|login|register|forgot-password|reset-password|location\/[^/]+|dashboard))?$/;

/**
 * Whether the current URL is a public browse surface that must not
 * force redirect to login on incidental 401s (e.g. stale session + wrong client).
 *
 * Note: `?embed=1` alone does NOT qualify — only explicit path patterns.
 */
export function isPublicBrowsePath(pathname: string, hostname?: string): boolean {
  if (isAcademySubdomainHost(hostname)) {
    if (pathname === '/' || pathname === '/login' || pathname === '/book-private') return true;
    if (pathname.startsWith('/lessons') || pathname.startsWith('/book/')) return true;
    if (pathname.startsWith('/location/')) return true;
    if (pathname.startsWith('/academy/')) return true;
    if (
      pathname === '/court-hire' ||
      pathname === '/join' ||
      pathname === '/membership' ||
      pathname === '/register' ||
      pathname === '/forgot-password' ||
      pathname === '/reset-password'
    ) {
      return true;
    }
    return false;
  }

  return (
    ACADEMY_PATH_PUBLIC.test(pathname) ||
    CLUB_PATH_PUBLIC.test(pathname) ||
    ORG_PATH_PUBLIC.test(pathname)
  );
}
